import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/arrow-left-s-line.png'


const _hoisted_1 = { class: "product-detail" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "detail-images" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "back-button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
      }, _cache[2] || (_cache[2] = [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "返回",
          class: "back-icon"
        }, null, -1)
      ])),
      _createElementVNode("h1", null, _toDisplayString(_ctx.product.productName), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailImages, (image, index) => {
          return (_openBlock(), _createElementBlock("img", {
            key: index,
            src: image,
            alt: '产品详情图 ' + (index + 1),
            class: "detail-image"
          }, null, 8, _hoisted_5))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("button", {
        class: "exchange-button",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleExchange && _ctx.handleExchange(...args)))
      }, "立即兑换")
    ])
  ]))
}